import React from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import ProfileSection from "./userSettings/ProfileSection";
import SecuritySection from "./userSettings/SecuritySection";
import NotificationsSection from "./userSettings/NotificationsSection";
import KYCSection from "./userSettings/KYCSection";
import FinancialInfoSection from "./userSettings/FinancialInfoSection";
import PrivacyConsentSection from "./userSettings/PrivacyConsentSection";
import RolesSection from "./userSettings/RolesSection";
import AccountActivitySection from "./userSettings/AccountActivitySection";
import OffboardingSection from "./userSettings/OffboardingSection";

// Estructura modular: cada secciÃ³n puede ser un componente independiente
// para facilitar la serializaciÃ³n, pruebas y mantenimiento futuro.

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`user-settings-tabpanel-${index}`}
            aria-labelledby={`user-settings-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default function UserSettingsPage() {
    const [tab, setTab] = React.useState(0);
    const handleChange = (event, newValue) => setTab(newValue);

    return (
        <Paper sx={{ maxWidth: 900, mx: "auto", mt: 4, p: 2 }} elevation={3}>
            <Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>
                ConfiguraciÃ³n de Usuario
            </Typography>
            <Tabs
                value={tab}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="Secciones de configuraciÃ³n de usuario"
            >
                <Tab label="Perfil Personal" />
                <Tab label="Seguridad" />
                <Tab label="Notificaciones" />
                <Tab label="VerificaciÃ³n KYC" />
                <Tab label="InformaciÃ³n Financiera" />
                <Tab label="Privacidad y Consentimientos" />
                <Tab label="Roles y Funciones" />
                <Tab label="Actividad de Cuenta" />
                <Tab label="DesactivaciÃ³n / Offboarding" />
            </Tabs>
            {/* Paneles de cada secciÃ³n, con documentaciÃ³n inline para modularidad */}
            <TabPanel value={tab} index={0}>
                <ProfileSection />
            </TabPanel>
            <TabPanel value={tab} index={1}>
                <SecuritySection />
            </TabPanel>
            <TabPanel value={tab} index={2}>
                <NotificationsSection />
            </TabPanel>
            <TabPanel value={tab} index={3}>
                <KYCSection />
            </TabPanel>
            <TabPanel value={tab} index={4}>
                <FinancialInfoSection />
            </TabPanel>
            <TabPanel value={tab} index={5}>
                <PrivacyConsentSection />
            </TabPanel>
            <TabPanel value={tab} index={6}>
                <RolesSection />
            </TabPanel>
            <TabPanel value={tab} index={7}>
                <AccountActivitySection />
            </TabPanel>
            <TabPanel value={tab} index={8}>
                <OffboardingSection />
            </TabPanel>
        </Paper>
    );
} 